import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import FilterModel from "./filter-model";
import SortModel from "./sort-model";
import FilterMobile from "./filter-model/filter-model-mobile";
import SortMobile from "./sort-mobile";
import NotificationModel from "./notification-model";
import NotificationMobileSidebar from "./notification-model/notification-model-mobile";
import { useUnreadNotificationsCount } from "../../../hooks/react-query/calling-pipeline/useUnreadNotificationsCount";

export default function CallingPipelineHeader() {
  const [showFilterModel, setShowFilterModel] = React.useState(false);
  const [showNotificationModel, setShowNotificationModel] = React.useState(false);
  const [showModel, setShowModel] = React.useState(false);
  const menu = useRef(null);
  const op: any = useRef(null);
  const notificationRef: any = useRef(null);
  const { data: counts } = useUnreadNotificationsCount();
  const [isMobile, setIsMobile] = useState(false);
  const handleResize = () => {
    if (window.innerWidth <= 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };
  useEffect(() => {
    setIsMobile(window.innerWidth <= 768 ? true : false);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={styles.header}>
      <div className={styles.title}>Calling Pipeline</div>
      <div className={styles.imgWrap}>
        <img
            src={`/images/${counts?.data?.count > 0 ? "notification-bell-unread.svg" : "notification-bell.svg"}`}
          width={24}
          alt="exc"
          className={styles.iconImage}
          onClick={(e) => {
            if (isMobile) {
              setShowNotificationModel(!showNotificationModel);
              return;
            } else if (op?.current) {
              notificationRef?.current.toggle(e);
            }
          }}
        />
        <NotificationModel popRef={notificationRef} />
        <NotificationMobileSidebar
          showModel={showNotificationModel}
          setShowModel={setShowNotificationModel}
        />
        <img
          src="/images/filter1.svg"
          width={24}
          alt="exc"
          className={styles.iconImage}
          onClick={(e) => {
            if (isMobile) {
              setShowFilterModel(!showFilterModel);
              return;
            } else if (op?.current) {
              op?.current.toggle(e);
            }
          }}
        />
        <img
          src="/images/sort-inv.svg"
          width={24}
          alt="exc"
          className={styles.iconImage}
          onClick={(e) => {
            if (isMobile) {
              setShowModel(!showModel);
            } else if (menu?.current) {
              (menu.current as any)?.toggle(e);
            }
          }}
        />
      </div>

      <SortMobile showModel={showModel} setShowModel={setShowModel} />
      <FilterMobile
        showModel={showFilterModel}
        setShowModel={setShowFilterModel}
      />
      <FilterModel popRef={op} />
      <SortModel popRef={menu} />
    </div>
  );
}
